export default __webpack_public_path__ + "static/media/Gida of Black Oblivion.065d2e8c.jpg";